import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { staffPayrollActions } from 'store';
// import { DownloadFile, FLAGGED_VALUES, Images, PermissionList, RolePermission, useModal } from 'utils';
// import { AccordionFullTable, CustomDelete, SelectActions } from 'components';
// import { payrollTableInfo, timeSheetTabEnums } from './constants';
// import { Resolve } from './fragments';
// import { getProcessedPayrollBatches } from '../../store/staffPayroll/staffPayroll.action';
import { ProcessPayrollTable } from './fragments/processPayrollTable';

// const UN_PROCESS_ACTION_TYPE = 'UN_PROCESS_PAYROLL';
export const ProcessesPayroll = ({}) => {
    // const dispatch = useDispatch();
    // const navigate = useNavigate();
    // const info = location?.state;
    // const processed = useSelector((state) => state?.staffPayroll?.processedPayroll);
    // const { open } = useModal();
    // const { loadDownload, downloadBatch } = DownloadFile();
    // const [currentId, setCurrentId] = useState(null);
    // const [selectedList, setSelectedList] = useState([]);
    //
    // const renderParams = () => {
    //     const filteredInfo = {
    //         ...info,
    //     };
    //     filteredInfo.skip = info?.skip ? info?.skip : 0;
    //     filteredInfo.limit = 50;
    //     delete filteredInfo.page;
    //     delete filteredInfo.activeTab;
    //     delete filteredInfo.staffFull;
    //     delete filteredInfo.start;
    //     delete filteredInfo.end;
    //
    //     info?.start ? filteredInfo.startDate = info?.start : delete filteredInfo.startDate;
    //     info?.end ? filteredInfo.endDate = info?.end : delete filteredInfo.endDate;
    //
    //     if (info?.flag === FLAGGED_VALUES.INCOMPLETE_UNIT) {
    //         filteredInfo.flag = true;
    //     } else if (info?.flag === FLAGGED_VALUES.NOT_INCOMPLETE_UNIT) {
    //         filteredInfo.flag = false;
    //     } else {
    //         delete filteredInfo.flag;
    //     }
    //
    //     // if (info?.staffs?.length) {
    //     //     filteredInfo.staffs = info?.staffs?.map((i) => i.id);
    //     // } else {
    //     //     delete filteredInfo.staffs;
    //     // }
    //
    //     return filteredInfo;
    // };
    //
    // const getDates = (loading) => {
    //     dispatch(staffPayrollActions.getProcessedPayroll({ ...renderParams() }, loading));
    //
    // };
    //
    // useEffect(() => {
    //     getDates();
    // }, [info]);

    // const download = (e, id) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     downloadBatch(id);
    //     setCurrentId(id);
    // };

    // const handleOpenResolve = (e, item) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     open(
    //         <Resolve
    //             id={item?.id}
    //             afterSuccess={afterSuccess}
    //             displayId={item?.apptDisplayId}
    //         />,
    //     );
    // };

    // const afterSuccess = () => {
    //     getDates('noLoad');
    // };

    // const handleCheck = (ev, item, name) => {
    //      if(name === 'all' || name === 'selectAll'){
    //         // setSelectedList(processed?.batches?.map((i) => i?.id));
    //          setSelectedList(processed?.batches?.length === selectedList?.length ? [] : processed?.batches?.map((i) => i?.id));
    //      } else {
    //         setSelectedList((prev) => prev?.includes(item?.id) ? prev.filter(id => id !== item?.id) : [...prev, item?.id]);
    //     }
    // };

    // const removeSelectedList = () => {
    //     setSelectedList([]);
    // };

    // const afterUnProcess = () => {
    //     afterSuccess('noLoad');
    //     removeSelectedList();
    // };

    // const unProcess = () => {
    //     open(
    //         <CustomDelete
    //             info="Un-process Batch?"
    //             text="You're about to un-process this batch. This action cannot be undone."
    //             innerText="Un-process"
    //             handleDel={() => dispatch(staffPayrollActions.unProcessPayroll(selectedList))}
    //             afterSuccess={afterUnProcess}
    //             actionType={UN_PROCESS_ACTION_TYPE}
    //             body={
    //                 <div className="deleting-client-info-box" style={{ flexDirection: 'column', alignItems: 'start' }}>
    //                     <div className="flex-align-start" style={{ gap: 8 }}>
    //                         <img style={{ marginTop: 4 }} src={Images.fileBlack} alt="icon" />
    //                         <div>
    //                             <p style={{ fontWeight: 600 }}>{`${selectedList?.length} timesheets `}</p>
    //                             <p style={{ fontSize: 12, color: '#475467', fontWeight: 400 }}>
    //                                 These timesheets will be reset to appointment data.
    //                             </p>
    //                         </div>
    //                     </div>
    //                 </div>
    //             }
    //         />,
    //     );
    // };
    // dispatch(staffPayrollActions.processedPayrollBatches({ ...renderParams() }, loading));

    return (
        <div>
            {/*{!!selectedList?.length &&*/}
            {/*    <SelectActions*/}
            {/*        selectedList={selectedList?.length}*/}
            {/*        selectAll={handleCheck}*/}
            {/*        selectInnetText={selectedList?.length === processed?.batches?.length ? 'Clear Selection' : 'Select All'}*/}
            {/*        submitText={'Un-process Payroll'}*/}
            {/*        submitBtnIcon={Images.undo}*/}
            {/*        submitClaims={unProcess}*/}
            {/*        removeSelected={removeSelectedList}*/}
            {/*        submitPermission={RolePermission([PermissionList.TIMESHEET_PROCESS?.code])}*/}
            {/*    />*/}
            {/*}*/}

            <ProcessPayrollTable />

            {/*<AccordionFullTable*/}
            {/*    tableInfo={payrollTableInfo(*/}
            {/*        download, currentId, loadDownload, handleOpenResolve, afterSuccess,*/}
            {/*        handleCheck, processed?.batches, selectedList,*/}
            {/*    )}*/}
            {/*    // list={sortListByKey(processed?.batches, 'processorName')}*/}
            {/*    list={processed?.batches}*/}
            {/*    listCount={processed?.count}*/}
            {/*    onRowClick={(e) => navigate(`/timesheet/${e?.id}`, { tabType: timeSheetTabEnums.PROCESSED })}*/}
            {/*    onItemClick={(expand, item) => expand && dispatch(staffPayrollActions.getProcessedPayrollBatches({skip: 0, limit: 10}, item?.id))}*/}
            {/*    // onItemClick={(expand, item) => dispatch(staffPayrollActions.getProcessedPayrollBatches(, ))}*/}
            {/*/>*/}
        </div>
    );
};
